// @flow
import { Box, useTheme } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const SoeStatus = props => {
  const theme = useTheme();
  const { t } = useTranslation();
  const label = t('sentences:pages.report.summary_details.soe');
  const { status, size = '38px', style, title, ...rest } = props;
  const diameter =
    typeof size === 'number'
      ? size
      : parseInt(String(size).replace(/px/gi, ''), 10) || 30;
  const purple = theme.palette.purple.main;
  const grey = '#bdbdbd';
  const fontPx = Math.max(7, Math.round(diameter * 0.34));

  const baseSx = {
    width: `${diameter}px`,
    minWidth: `${diameter}px`,
    height: `${diameter}px`,
    minHeight: `${diameter}px`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: `${fontPx}px`,
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
  };

  if (status === 'identified') {
    return (
      <Box
        sx={{
          ...baseSx,
          border: `1.5px solid ${purple}`,
          backgroundColor: 'transparent',
          color: purple,
        }}
        style={style}
        title={title}
        {...rest}
      >
        {label}
      </Box>
    );
  }

  if (status === 'not_soe') {
    return (
      <Box
        sx={{
          ...baseSx,
          border: `1.5px solid ${grey}`,
          backgroundColor: 'transparent',
          color: grey,
          opacity: 0.8,
        }}
        style={style}
        title={title}
        {...rest}
      >
        {label}
      </Box>
    );
  }

  return null;
};

export default SoeStatus;
